import type React from "react";
import {memo} from "react";

import type {MessageRule} from "../../models/messageRule";
import type {OptionType} from "../Select";
import SelectGeneric from "../SelectGeneric";

type SelectEventValue = MessageRule["event"];

type SelectEventOption = OptionType<SelectEventValue>;

export const eventOptions: SelectEventOption[] = [
    {
        value: "checkin",
        label: "Check-In"
    },
    {
        value: "checkout",
        label: "Check-Out"
    },
    {
        value: "occupied",
        label: "When Occupied"
    },
    {
        value: "inquiry",
        label: "Booking Inquiry"
    },
    {
        value: "timedout",
        label: "Pre-approval Expired"
    },
    {
        value: "pending",
        label: "Booking Request"
    },
    {
        value: "booking",
        label: "Booking Confirmation"
    },
    {
        value: "doorUnlocked",
        label: "Door Was Unlocked"
    },
    {
        value: "checkinChanged",
        label: "Check-In Changed"
    },
    {
        value: "checkoutChanged",
        label: "Check-Out Changed"
    },
    {
        value: "guestsChanged",
        label: "Number of Guests Changed"
    },
    {
        value: "petsChanged",
        label: "Number of Pets Changed"
    },
    {
        value: "cancelled",
        label: "Booking Cancelled"
    }
];

type Props = {
    value?: SelectEventValue;
    isDisabled?: boolean;
    onChange: (value: SelectEventValue) => void;
};

const SelectEvent: React.FC<Props> = ({value = "checkin", onChange, isDisabled}) => {
    return (
        <SelectGeneric
            isDisabled={isDisabled}
            options={eventOptions}
            placeholder="Event..."
            testID="select-event"
            value={value}
            onChange={onChange}
        />
    );
};

export default memo(SelectEvent);
